import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import * as hotjarTracking from './tools/hotjar';
import { validateEventData } from './validate-event-data';

import type { SiteGroupingData } from './utils';

interface IntegrationStepArgs {
  name: string;
  type?: string;
  step: string;
  groupData: SiteGroupingData | undefined;
  data: Record<string, string | number>;
}

/**
 * Track an integration step.
 */

export const integrationStep = ({
  name,
  type,
  step,
  groupData,
  data,
}: IntegrationStepArgs): void => {
  const isValid = validateEventData('Track.integrationStep', [name, step, groupData]);

  if (isValid) {
    const eventData = {
      ...data,
      ...groupData,
      ...(typeof type !== 'undefined' && { integration_type: type }),
      integration_name: name,
      integration_step: step,
    };

    hotjarTracking.tagRecording(`Integration step: ${name} - ${step}`);
    Segment.track('Integration Step', eventData);
  }
};
